import React, { useContext, useState, useRef, useEffect } from 'react'
import AppContext from '../context/app'
import useGetAllCountry from '../hooks/useGetAllCountry'
import { GET_FLAG_URL } from '../../constants'
import Dropdown from 'react-bootstrap/Dropdown'
import Button from 'react-bootstrap/Button'
import Stack from 'react-bootstrap/Stack'
import chevrondowniconwhite from '../images/svgs/chevron-down-icon-white.svg'
import { css } from '@emotion/react'
import classNames from 'classnames'

export default function CountrySelector({ className, style }) {
    const maxHeight = 300
    const allCountry = useGetAllCountry()
    const { country } = useContext(AppContext)

    const inputRef = useRef(null)
    const [show, setShow] = useState(false)
    const [userInput, setUserInput] = useState('')

    function changeCountry(country) {
        const event = new CustomEvent("COUNTRY_CURRENCY_CHANGED", { detail: country })
        if (typeof window !== 'undefined') window.dispatchEvent(event)
    }

    const toggle = (e) => {
        setShow(!show)
    }

    useEffect(() => {
        if (show) inputRef.current.focus()
        else setUserInput('')
    }, [show])

    return (
        <Dropdown onToggle={toggle} show={show} className={className} style={style} align='end'>
            <Button
                variant=''
                className='text-light p-0 border-0'
                onClick={toggle}
                style={{ fontSize: 18 }}
            >
                {`${country?.countryIso?.toUpperCase()} (${country?.currencySymbol})`}
            </Button>

            <Dropdown.Toggle split variant="" className='border-0 py-1'>
                <img src={chevrondowniconwhite} alt='' />
            </Dropdown.Toggle>

            <Dropdown.Menu className='bg-black border border-dark p-3 m-0' style={{borderTopRightRadius: 0, width: 296}}>
                <input
                    ref={inputRef}
                    placeholder='Filter countries'
                    className='placeholder-font-family-primary my-2 w-100'
                    value={userInput}
                    onChange={(e) => setUserInput(e.target.value)}
                    style={{ fontSize: 18 }}
                    autoFocus
                    autoComplete='false'
                />

                <div id='country-menu' style={{ 
                    maxHeight,
                    overflowX: 'hidden',
                    overflowY: 'auto',
                }}>
                    {allCountry
                        .filter(({ name }) => name?.toLowerCase()?.includes(userInput?.toLowerCase()))
                        .map(c => {
                            const { id, name, countryIso } = c
                            const isActive = countryIso === country?.countryIso

                            return (
                                <Dropdown.Item
                                    key={id}
                                    as={Button}
                                    onClick={() => changeCountry(c)}
                                    className={classNames(
                                        { 'active': isActive },
                                        'ff-secondary px-0',
                                    )}
                                    style={{ paddingLeft: 12, paddingRight: 12, }}
                                    title={name}
                                    active={isActive}
                                >
                                    <Stack direction='horizontal' className='align-items-center' gap={1}>
                                        <img src={GET_FLAG_URL(countryIso)} alt='' width={32} loading='lazy' />
                                        <span
                                            style={{ fontSize: 16 }}
                                            className={`ff-primary text-uppercase text-light`}
                                        >
                                            {name}
                                        </span>
                                    </Stack>
                                </Dropdown.Item>
                            )
                        })}
                </div>
            </Dropdown.Menu>
        </Dropdown>
    )
}